<div class="inline-item">
  <!-- header -->
  <div class="inline-item__header">
    <!-- slot / summary -->
    <div class="inline-item__summary">
      <ng-content select="inline-summary"></ng-content>
    </div>

    <!-- status -->
    <ng-container *ngIf="showValidation">
      <div class="inline-item__status">
        <lds-tooltip cursor="help" message="incomplete information">
          <lds-icon name="alert" appearance="error"></lds-icon>
        </lds-tooltip>
      </div>
    </ng-container>

    <!-- actions -->
    <div class="inline-item__actions">
      <!-- action / remove -->
      <ng-container *ngIf="isRemovable">
        <lds-icon-button
          icon="remove"
          variation="link"
          (onClick)="onClickRemove()">
        </lds-icon-button>
      </ng-container>

      <!-- action / expandable -->
      <ng-container *ngIf="isExpandable">
        <lds-icon-button
          [icon]="isCollapsed ? 'arrow-down' : 'arrow-up'"
          variation="link"
          [isRounded]="true"
          (onClick)="onToggleExpand()">
        </lds-icon-button>
      </ng-container>
    </div>
  </div>

  <!-- slot / content -->
  <div
    class="inline-item__content"
    [ngClass]="{ 'inline-item__content--hidden': isCollapsed }">
    <ng-content select="inline-content"></ng-content>
  </div>
</div>
